//@getters
import { GetterTree } from "vuex";
import { homeState } from "./state";

export const getters: GetterTree<any, homeState> = {};
